/**
 * Publishable event facts. Times live in `src/event/schedule.ts`; this holds
 * the words and the place.
 */

export const EVENT_NAME = 'MPworks Hackathon 2026'
export const EVENT_THEME = 'From Idea to Impact'

export const VENUE = {
  name: 'MetaPhase HQ',
} as const
